import styled from 'styled-components';

export default styled.div`
	flex-direction: column;
	gap: var(--gap);
	max-height: 40rem;
`;
